import createCrudVuexModule from "@/store/crud";

export const abroadThirdParty = createCrudVuexModule({
  namespaced: true,
  path: "/library/abroad-third-party",
  moduleName: `abroad-third-party`,
});

export const workspaceAbroadThirdParty = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/abroad-third-party",
});

export const managementAbroadThirdParty = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/abroad-third-party",
});
